import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { LEAD_STAGES, LEAD_STAGES_COPY } from 'models/Lead';
import { LeadStagesCopies } from 'models/DealRoom';

export default function useLeadStagesCopy() {
  const { t } = useTranslation();

  const getCopies = useCallback(
    (leadStagesCopies?: LeadStagesCopies) => ({
      [LEAD_STAGES.ENQUIRE]:
        leadStagesCopies?.[LEAD_STAGES.ENQUIRE] || t(LEAD_STAGES_COPY.ENQUIRY),
      [LEAD_STAGES.ACCEPT]:
        leadStagesCopies?.[LEAD_STAGES.ACCEPT] || t(LEAD_STAGES_COPY.ACCEPTED),
      [LEAD_STAGES.CONFIRM]:
        leadStagesCopies?.[LEAD_STAGES.CONFIRM] || t(LEAD_STAGES_COPY.PROSPECT),
      [LEAD_STAGES.OFFER]:
        leadStagesCopies?.[LEAD_STAGES.OFFER] || t(LEAD_STAGES_COPY.BIDDER),
    }),
    [t],
  );

  return { getCopies };
}
